import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { PlatformService } from '@big-direkt/utils/shared';

export const canActivatePhoneNumbersGuard: CanActivateFn = route => {
    const platformService = inject(PlatformService);
    const documentRef = inject<Document>(DOCUMENT);

    if (!route.url.length) {
        return true;
    }

    const path = route.url[0]?.path;

    if (!path || !/(tel|fax):\d+/.test(path)) {
        return true;
    }

    if (platformService.isPlatformServer()) {
        return false;
    }

    documentRef.location.assign(path);

    return false;
};
